/* eslint-disable */
import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from 'react-redux-toastr';
import Webcam from "react-webcam";
import { getProfileInfoDisplay } from '../../application_management/actions/advertisementAction';
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { getResizedImage } from '../../helpers/ImageHelper';
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import '../../styles/profile.css';
import { disableAllSaveAfterSubmit, getFormattedLastUpdatedDate, PostLivePhoto, PostUploadPhotoAndSignature, setHindiSignaturesrc, setImagesrc, setLiveImagesrc, setSignaturesrc, showImageSignatureFlag, submitProfile } from "../actions/profileAction";
import common from '../labels/common_en.json';
import profile from '../labels/personal_information_en.json';
import numberformat from "../labels/serial_nos_en.json";
import profileuploadphotosignature from '../labels/upload_photo_and_signature_en.json';
import { getPrfileSummaryDetails } from './../../my_account/actions/myAccountAction';
function UploadPhotoAndSignature(props) {
  const defaultImage = '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';

  const [uploadImage, setUploadImage] = useState({
    showCandidatePhoto: "",
    sendCandidatePhotoFile: "",
    showCandidatePhotoBase64: "",
    defaultCandidatePhoto: defaultImage
  })
  const [uploadLiveImage, setUploadLiveImage] = useState({
    showCandidatePhoto: "",
    sendCandidatePhotoFile: "",
    showCandidatePhotoBase64: "",
    defaultCandidatePhoto: defaultImage
  })

  const [uploadSignature, setUploadSignature] = useState({
    showSignature: "",
    sendSignature: "",
    showSignatureBase64: "",
    defaultSignaturePhoto: defaultImage
  });
  const [uploadHindiSignature, setUploadHindiSignature] = useState({
    showHindiSignature: "",
    sendHindiSignature: "",
    showHindiSignatureBase64: "",
    defaultHindiSignaturePhoto: defaultImage
  });
  let [errorPhoto, setErrorPhoto] = useState("");
  let [errorLivePhoto, setErrorLivePhoto] = useState("");
  let [errorSign, setErrorSign] = useState("");
  let [errorHindiSign, setErrorHindiSign] = useState("");
  let [showModal, setShowModal] = useState(false);
  const getUploadedImages = useSelector(state => state.profile.uploadedPhotoAndSignature);
  const getCropImages = useSelector(state => state.profile.cropImageSRC);
  const getCropLiveImages = useSelector(state => state.profile.cropLiveImageSRC);
  const getCropSignature = useSelector(state => state.profile.cropSignatureSRC);
  const getCropHindiSignature = useSelector(state => state.profile.cropHindiSignatureSRC);
  const { profileStatus, flgSubmittableList, setUploadedPhotoMessage, setShowModalStatus, setLivePhotoMessage, livePhotoMessage, livephotoFlg, setLivephotoFlg, setPhotoFlg, liveimageSRC } = useSelector(state => state.profile);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const isDisableAllTabSave = useSelector(state => state.profile.isDisableAllTabSave);
  const [showName, setShowName] = useState(false);
  const [timer, setTimer] = useState(10)
  const [intervalId, setIntervalId] = useState(null);
  const dispatch = useDispatch();
  const validFileTypes = ['image/jpeg', 'image/png'];
  const allowedExtensions = ['jpg', 'jpeg', 'png'];

  useEffect(() => {
    if (!props.profileStatus) {
      dispatch(disableAllSaveAfterSubmit(false));
    } else if (
      props.enableEditProfileWithLock?.editProfileWithLock == "1"
    ) {
      dispatch(disableAllSaveAfterSubmit(false));
    } else {
      dispatch(disableAllSaveAfterSubmit(true));
    }
  }, [dispatch, props.profileStatus, props.enableEditProfileWithLock?.editProfileWithLock]);


  const { moduleList } = useSelector(state => state.loginReducer, shallowEqual);
  const [arraymModule, setarraymModule] = useState({})
  const [submitLockProfile, setsubmitLockProfile] = useState({});
  const [showSuccessLivePhotoModal, setShowSuccessLivePhotoModal] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [termsAndCondition, setTermsAndCondition] = useState(false);
  const [editHindiSignFlg, setEditHindiSignFlg] = useState(false);
  const [editEngSignFlg, setEditEngSignFlg] = useState(false);
  const [editLivePhotoFlg, setEditLivePhotoFlg] = useState(false);

  useEffect(() => {
    setarraymModule(moduleList && moduleList.filter((ele) => ele.moduleName === "PHOTO_SIGN_INFO")[0])
    setsubmitLockProfile(moduleList && moduleList.filter((ele) => ele.moduleName === "SUBMIT_LOCK_PROFILE")[0])
  }, [moduleList])


  const nameAndCameraPop = () => {
    setIsCameraOn(false)
  }

  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";

  // const onChangeImage = (event) => {
  //   if (event.target.files.length === 0) {
  //     return
  //   }

  //   const selectedFile = event.target.files[0];

  //     const fileType = selectedFile.type;

  //     // Check for valid file type
  //     if (!validFileTypes.includes(fileType)) {
  //       setError("Invalid file type. Only JPG, PNG are allowed.");
  //       return;
  //     }


  //     const extension = selectedFile.name.split('.').pop().toLowerCase();

  //     // Check if the extension is allowed
  //     if (!allowedExtensions.includes(extension)) {
  //       setError('Only .jpg, .jpeg, and .png files are allowed.');
  //       return;
  //     }
  //   const file = event.target.files[0];
  //   const maxFileSize = 35 * 1024; 
  //   if (file.size > maxFileSize) {
  //     toastr.error(commonENLabels.COMMON.IMAGE_SIZE_NOTE)
  //     return;
  //   }
  //   setUploadImage({
  //     showCandidatePhoto: window.URL.createObjectURL(event.target.files[0]),
  //     sendCandidatePhotoFile: event.target.files[0],
  //     showCandidatePhotoBase64: "",
  //     defaultCandidatePhoto: ""
  //   })

  //   const reader = new FileReader();
  //   reader.addEventListener('load', () => {
  //     dispatch(setImagesrc(reader.result))
  //     event.target.value = ""
  //   });
  //   reader.readAsDataURL(event.target.files[0]);
  // }
  const maxFileSize = 35 * 1024;

  const onChangeImage = (event) => {
    if (event.target.files.length === 0) {
      return;
    }
    const selectedFile = event.target.files[0];
    const fileType = selectedFile.type;
    const extension = selectedFile.name.split('.').pop().toLowerCase();
    if (!validFileTypes.includes(fileType) || !allowedExtensions.includes(extension)) {
      toastr.error(commonENLabels.COMMON.INVALID_FILE_TYPE_ERR);
      return;
    }
    if (selectedFile.size > maxFileSize) {
      toastr.error(commonENLabels.COMMON.IMAGE_SIZE_NOTE);
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result).subarray(0, 4);
      let header = '';
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      const isValidSignature =
        header === '89504e47' ||
        header.startsWith('ffd8');
      if (!isValidSignature) {
        toastr.error(commonENLabels.COMMON.INVALID_FILE_CONTENT);
        return;
      }
      setUploadLiveImage({
        showCandidatePhoto: window.URL.createObjectURL(selectedFile),
        sendCandidatePhotoFile: selectedFile,
        showCandidatePhotoBase64: "",
        defaultCandidatePhoto: ""
      });

      const readerBase64 = new FileReader();
      readerBase64.onload = () => {
        dispatch(setImagesrc(readerBase64.result));
        event.target.value = "";
      };
      readerBase64.readAsDataURL(selectedFile);
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  const onChangeSignature = (event) => {
    if (event.target.files.length === 0) {
      return;
    }

    setEditEngSignFlg(true)

    const selectedFile = event.target.files[0];
    const fileType = selectedFile.type;
    const extension = selectedFile.name.split('.').pop().toLowerCase();
    const maxFileSize = 20 * 1024;

    if (!validFileTypes.includes(fileType) || !allowedExtensions.includes(extension)) {
      toastr.error(commonENLabels.COMMON.INVALID_FILE_TYPE_ERR_SIGNATURE);
      return;
    }

    if (selectedFile.size > maxFileSize) {
      toastr.error(commonENLabels.COMMON.IMAGE_SIZE_NOTE_FOR_SIGNATURE);
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result).subarray(0, 4);
      let header = '';
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      const isValidSignature =
        header === '89504e47' ||
        header.startsWith('ffd8');

      if (!isValidSignature) {
        toastr.error(commonENLabels.COMMON.INVALID_FILE_CONTENT_SIGNATURE);
        return;
      }
      setUploadSignature({
        showSignature: window.URL.createObjectURL(selectedFile),
        sendSignature: selectedFile,
        showSignatureBase64: "",
        defaultSignaturePhoto: defaultImage
      });
      const readerBase64 = new FileReader();
      readerBase64.onload = () => {
        dispatch(setSignaturesrc(readerBase64.result));
        event.target.value = "";
      };
      readerBase64.readAsDataURL(selectedFile);
    };
    reader.readAsArrayBuffer(selectedFile);
  };

  const { profileSummaryInfo, profileDetailsInfo } = useSelector((state) => state.myaccount, shallowEqual);


  // const { profileDetailsInfo } = useSelector((state) => state.myaccount, shallowEqual);


  // const getLiveImage = async () => {
  //   const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  //   let token = session.jwtResponse && session.jwtResponse.token;
  //   if (!profileId) {
  //     profileId = session.profileId;
  //   }
  //   let response;
  //   try {
  //     response = await API.get(PROFILE_INFO_DISPLAY + `/${profileId}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     if (response != null) {
  //       dispatch(hideLoader());
  //     }
  //     dispatch({
  //       type: SET_PROFILE_INFO_DISPLAY,
  //       payload: response.data,
  //     });
  //   } catch (err) {
  //     dispatch(hideLoader());
  //     toastr.error(advertisementDetailsLabel.ERR_GETTING_PROFILE_INFO);
  //     return;
  //   }
  // }



  useEffect(() => {
    dispatch(getPrfileSummaryDetails())
    // getLiveImage()
  }, [])

  const onChangeHindiSignature = (event) => {
    if (event.target.files.length === 0) {
      return;
    }
    setEditHindiSignFlg(true)
    const selectedFile = event.target.files[0];
    const fileType = selectedFile.type;
    const extension = selectedFile.name.split('.').pop().toLowerCase();
    const maxFileSize = 20 * 1024;

    if (!validFileTypes.includes(fileType) || !allowedExtensions.includes(extension)) {
      toastr.error(commonENLabels.COMMON.INVALID_FILE_TYPE_ERR_SIGNATURE);
      return;
    }

    if (selectedFile.size > maxFileSize) {
      toastr.error(commonENLabels.COMMON.IMAGE_SIZE_NOTE_FOR_SIGNATURE);
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result).subarray(0, 4);
      let header = '';
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      const isValidHindiSignature =
        header === '89504e47' ||
        header.startsWith('ffd8');

      if (!isValidHindiSignature) {
        toastr.error(commonENLabels.COMMON.INVALID_FILE_CONTENT_SIGNATURE);
        return;
      }
      setUploadHindiSignature({
        showHindiSignature: window.URL.createObjectURL(selectedFile),
        sendHindiSignature: selectedFile,
        showHindiSignatureBase64: "",
        defaultSignaturePhoto: defaultImage
      });
      const readerBase64 = new FileReader();
      readerBase64.onload = () => {
        dispatch(setHindiSignaturesrc(readerBase64.result));
        event.target.value = "";
      };
      readerBase64.readAsDataURL(selectedFile);
    };
    reader.readAsArrayBuffer(selectedFile);
  };



  // const onChangeSignature = (event) => {
  //   if (event.target.files.length === 0) {
  //     return
  //   }
  //   const selectedFile = event.target.files[0];

  //     const fileType = selectedFile.type;

  //     // Check for valid file type
  //     if (!validFileTypes.includes(fileType)) {
  //       toastr.error("Invalid file type. Only JPG, PNG are allowed.");
  //       return;
  //     }
  //     const extension = selectedFile.name.split('.').pop().toLowerCase();

  //     // Check if the extension is allowed
  //     if (!allowedExtensions.includes(extension)) {
  //       toastr.error('Only .jpg, .jpeg, and .png files are allowed.');
  //       return;
  //     }

  //   const file = event.target.files[0];
  //   const maxFileSize = 20 * 1024; 
  //   if (file.size > maxFileSize) {
  //     toastr.error(commonENLabels.COMMON.IMAGE_SIZE_NOTE_FOR_SIGNATURE)
  //     return;
  //   }
  //   setUploadSignature({
  //     showSignature: window.URL.createObjectURL(event.target.files[0]),
  //     sendSignature: event.target.files[0],
  //     showSignatureBase64: "",
  //     defaultSignaturePhoto: defaultImage
  //   })
  //   const reader = new FileReader();
  //   reader.addEventListener('load', () => {
  //     dispatch(setSignaturesrc(reader.result))
  //     event.target.value = ""
  //   });
  //   reader.readAsDataURL(event.target.files[0]);
  // }


  const saveLivePhoto = async (sendCandidatePhotoFile) => {
    let livePhotoBlob = sendCandidatePhotoFile;
    let livePhotoVar = true;
    if (livePhotoBlob === "" || livePhotoBlob.type === 'text/html') {
      livePhotoVar = false;
      setErrorLivePhoto(profileuploadphotosignature.LIVE_PHOTO_REQUIRED);
    }
    setTermsAndCondition(false)

    if (livePhotoVar === true) {
      let data = {
        livephoto: sendCandidatePhotoFile
      }
      if (getUploadedImages.id && getUploadedImages.id > 0) {
        dispatch(PostLivePhoto(data, 'patch', setLivephotoFlg, setPhotoFlg))
      } else {
        dispatch(PostLivePhoto(data, 'post', setLivephotoFlg, setPhotoFlg))
      }
      setIsSaved(true)
    }
  }
  // const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let token = session.jwtResponse && session.jwtResponse.token;
  let profileId;
  useEffect(() => {
    if (!profileId) {
      profileId = session.profileId;
    }
    getProfileInfoDisplay(profileId)
  }, [profileId])



  const savePhotoAndSignature = async () => {
    // let photoBlob = uploadImage.sendCandidatePhotoFile;
    let livePhotoBlob = uploadLiveImage.sendCandidatePhotoFile;
    let signatureBlob = uploadSignature.sendSignature;
    let hindiSignatureBlob = uploadHindiSignature.sendHindiSignature;
    // let photoVar = true;
    let livePhotoVar = true;
    let signVar = true;
    let hindiSignVar = true;
    // if (photoBlob === "" || photoBlob.type === 'text/html') {
    //   photoVar = false;
    //   setErrorPhoto(profileuploadphotosignature.PHOTO_REQUIRED);
    // }
    // if (livePhotoBlob === "" || livePhotoBlob.type === 'text/html') {
    //   livePhotoVar = false;
    //   setErrorLivePhoto(profileuploadphotosignature.LIVE_PHOTO_REQUIRED);
    // }
    if (signatureBlob === "" || signatureBlob.type === 'text/html') {
      signVar = false;
      setErrorSign(profileuploadphotosignature.SIGNATURE_REQUIRED);
    } else {
      setEditEngSignFlg(false)
    }
    if (hindiSignatureBlob === "" || hindiSignatureBlob.type === 'text/html') {
      hindiSignVar = false;
      setErrorHindiSign(profileuploadphotosignature.SIGNATURE_REQUIRED_HINDI);
    } else {
      setEditHindiSignFlg(false)
    }

    setTermsAndCondition(false)


    // if (photoVar === true && livePhotoVar === true && signVar === true && hindiSignVar === true) {
    if (signVar === true && hindiSignVar === true) {
      let data = {
        // photo: await getResizedImage(photoBlob),
        // livephoto: await getResizedImage(livePhotoBlob),
        signature: await getResizedImage(signatureBlob),
        hinSignature: await getResizedImage(hindiSignatureBlob),
      }
      if (getUploadedImages.id && getUploadedImages.id > 0) {
        dispatch(PostUploadPhotoAndSignature(data, 'patch', setLivephotoFlg, setPhotoFlg))
      } else {
        dispatch(PostUploadPhotoAndSignature(data, 'post', setLivephotoFlg, setPhotoFlg))
      }
      setIsSaved(true)
    }
  }

  useEffect(() => {

    const fetchAndSetImages = async () => {
      // if (getUploadedImages.photo) {
      //   try {
      //     let base64PhotoResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.photo}`);
      //     let sendCandidatePhotoFile = await base64PhotoResponse.blob();
      //     setUploadImage({
      //       showCandidatePhotoBase64: getUploadedImages.photo,
      //       showCandidatePhoto: "",
      //       sendCandidatePhotoFile: sendCandidatePhotoFile,
      //       defaultCandidatePhoto: ""
      //     });
      //   } catch (error) {
      //     console.error('Error fetching photo:', error);
      //   }
      // }
      if (getUploadedImages.livephoto) {
        try {
          let base64PhotoResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.livephoto}`);
          let sendCandidateLivePhotoFile = await base64PhotoResponse.blob();
          setUploadLiveImage({
            showCandidatePhotoBase64: getUploadedImages.livephoto,
            showCandidatePhoto: "",
            sendCandidatePhotoFile: sendCandidateLivePhotoFile,
            defaultCandidatePhoto: ""
          });
        } catch (error) {
          console.error('Error fetching Live photo:', error);
        }
      }
      if (getUploadedImages.signature) {
        try {
          let base64SignResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.signature}`);
          let sendSignature = await base64SignResponse.blob();
          setUploadSignature({
            showSignatureBase64: getUploadedImages.signature,
            showSignature: "",
            sendSignature: sendSignature,
            defaultSignaturePhoto: ""
          });
        } catch (error) {
          console.error('Error fetching signature:', error);
        }
      }
      if (getUploadedImages.hinSignature) {
        try {
          let base64HindiSignResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.hinSignature}`);
          let sendHindiSignature = await base64HindiSignResponse.blob();
          setUploadHindiSignature({
            showHindiSignatureBase64: getUploadedImages.hinSignature,
            showHindiSignature: "",
            sendHindiSignature: sendHindiSignature,
            defaultSignaturePhoto: ""
          });
        } catch (error) {
          console.error('Error fetching Hindi signature:', error);
        }
      }
      let img = `data:image/png;base64,${getUploadedImages.photo}`;
      let liveimg = `data:image/png;base64,${getUploadedImages.livephoto}`;
      let sign = `data:image/png;base64,${getUploadedImages.signature}`;
      let hindiSign = `data:image/png;base64,${getUploadedImages.hinSignature}`;
      dispatch(setImagesrc(img));
      dispatch(setLiveImagesrc(liveimg));
      dispatch(setSignaturesrc(sign));
      dispatch(setHindiSignaturesrc(hindiSign));
    };
    fetchAndSetImages();
  }, [getUploadedImages, dispatch]);


  // useEffect(async () => {
  //   if(getUploadedImages.photo){
  //     let base64PhotoResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.photo}`);
  //     let sendCandidatePhotoFile = await base64PhotoResponse.blob();
  //     setUploadImage({
  //       showCandidatePhotoBase64: getUploadedImages.photo,
  //       showCandidatePhoto: "",
  //       sendCandidatePhotoFile: sendCandidatePhotoFile,
  //       defaultCandidatePhoto:""
  //     })
  //   }

  //   if(getUploadedImages.signature){
  //     let base64SignResponse = await fetch(`data:image/jpeg;base64,${getUploadedImages.signature}`);
  //     let sendSignature = await base64SignResponse.blob();
  //     setUploadSignature({
  //       showSignatureBase64: getUploadedImages.signature,
  //       showSignature: "",
  //       sendSignature: sendSignature,
  //       defaultSignaturePhoto:""
  //     })
  // }

  //   let img = 'data:image/png;base64,'+getUploadedImages.photo
  //   let sign = 'data:image/png;base64,'+getUploadedImages.signature
  //   dispatch(setImagesrc(img))
  //   dispatch(setSignaturesrc(sign))
  // }, [getUploadedImages]);


  useEffect(() => {
    if (getCropImages) {
      let getCropImagesKeyLength = Object.keys(getCropImages).length;
      if (getCropImages && getCropImagesKeyLength > 0) {
        fetch(getCropImages).then(r => r.blob()).then(blobImage =>
          setUpLoadLi({
            showCandidatePhoto: getCropImages,
            showCandidatePhotoBase64: "",
            sendCandidatePhotoFile: blobImage,
            defaultCandidatePhoto: defaultImage
          }));
      }
    }

  }, [getCropImages])

  useEffect(() => {

    if (getCropLiveImages) {
      let getCropImagesKeyLength = Object.keys(getCropLiveImages).length;
      if (getCropLiveImages && getCropImagesKeyLength > 0) {
        fetch(getCropLiveImages).then(r => r.blob()).then(blobImage =>
          setUploadLiveImage({
            showCandidatePhoto: getCropLiveImages,
            showCandidatePhotoBase64: "",
            sendCandidatePhotoFile: blobImage,
            defaultCandidatePhoto: defaultImage
          })
        );
      }
    }

  }, [getCropLiveImages]);

  useEffect(() => {
    if (getCropSignature && getCropSignature.cropSignature) {
      fetch(getCropSignature.cropSignature).then(r => r.blob()).then(blob =>
        setUploadSignature({
          showSignatureBase64: "",
          sendSignature: blob,
          showSignature: getCropSignature.cropSignature ? getCropSignature.cropSignature : "",
          defaultSignaturePhoto: defaultImage
        })
      );
    }
  }, [getCropSignature])

  useEffect(() => {
    if (getCropHindiSignature && getCropHindiSignature.cropHindiSignature) {
      fetch(getCropHindiSignature.cropHindiSignature).then(r => r.blob()).then(blob =>
        setUploadHindiSignature({
          showHindiSignatureBase64: "",
          sendHindiSignature: blob,
          showHindiSignature: getCropHindiSignature.cropHindiSignature ? getCropHindiSignature.cropHindiSignature : "",
          defaultHindiSignaturePhoto: defaultImage
        })
      );
    }
  }, [getCropHindiSignature])

  const showSignatureCropper = () => {
    dispatch(showImageSignatureFlag(false, true))
    setIsCameraOn(false);
  }

  const showImageCropper = () => {
    dispatch(showImageSignatureFlag(true, false))
    setIsCameraOn(false);
  }

  const showLiveImageCropper = () => {
    dispatch(showImageSignatureFlag(false, true, false))
    setIsCameraOn(false);
  }

  const removeCandidateImage = () => {
    setUploadImage({
      showCandidatePhoto: "",
      showCandidatePhotoBase64: "",
      sendCandidatePhotoFile: "",
      defaultCandidatePhoto: defaultImage
    });
  }
  const removeCandidateLiveImage = () => {
    setUploadLiveImage({
      showCandidatePhoto: "",
      showCandidatePhotoBase64: "",
      sendCandidatePhotoFile: "",
      defaultCandidatePhoto: defaultImage
    });

    setEditLivePhotoFlg(true)
  }
  const removeSignatureImage = () => {
    setUploadSignature({
      showSignatureBase64: "",
      sendSignature: "",
      showSignature: "",
      defaultSignaturePhoto: defaultImage
    });
    setTermsAndCondition(false)
    setEditEngSignFlg(true)

  }
  const removeHindiSignatureImage = () => {
    setUploadHindiSignature({
      showHindiSignatureBase64: "",
      sendHindiSignature: "",
      showHindiSignature: "",
      defaultHindiSignaturePhoto: defaultImage
    });

    setTermsAndCondition(false)
    setEditHindiSignFlg(true)

  }

  const popupName = () => {
    setShowName(true);
    setIsCameraOn(false);
    if (intervalId) {
      clearInterval(intervalId); // Clear any existing interval before starting a new one
    }

    // let countdown = 10; // Reset timer value
    setTimer(session.livePhotoCaptureTimer);

    const newInterval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(newInterval);
          setShowName(false);
          setIsCameraOn(true);
          return 0; // Stop at 0
        }
        return prevTimer - 1;
      });
    }, 1000);

    setIntervalId(newInterval); // Store the interval ID
  };

  const takePhoto = () => {
    setShowName(false);
    setIsCameraOn(true);
    setTimer(0);

    if (intervalId) {
      clearInterval(intervalId);
    }
  };


  const hideModal = () => {
    setShowName(false);
    setIsCameraOn(false);
    setShowSuccessLivePhotoModal(false)
    setTimer(0);

    if (intervalId) {
      clearInterval(intervalId);
    }
  }
  const webcamRef = React.useRef(null);

  // const capture = React.useCallback(
  //   async () => {
  //     const imageSrc = webcamRef.current.getScreenshot();
  //     const img = imageSrc.split(',')[1];

  //     let base64Response = await fetch(`data:image/jpeg;base64,${img}`);
  //     let sendCandidatePhotoFile = await base64Response.blob();
  //     setUploadLiveImage({
  //       showCandidatePhotoBase64: img,
  //       showCandidatePhoto: "",
  //       sendCandidatePhotoFile: sendCandidatePhotoFile,
  //       defaultCandidatePhoto: ""
  //     })


  //     let livePhotoBlob = uploadLiveImage.sendCandidatePhotoFile;
  //     let livePhotoVar = true;
  //     if (livePhotoBlob === "" || livePhotoBlob.type === 'text/html') {
  //       livePhotoVar = false;
  //       setErrorLivePhoto(profileuploadphotosignature.LIVE_PHOTO_REQUIRED);
  //     }
  //     setTermsAndCondition(false)

  //     dispatch(setLiveImagesrc(imageSrc))
  //     setShowSuccessLivePhotoModal(true)
  //     setIsCameraOn(false);
  //     setTimer(0);
  //     if (intervalId) {
  //       clearInterval(intervalId);
  //     }

  //     if (typeof saveLivePhoto === "function") {
  //       saveLivePhoto();
  //     } else {
  //       console.error("saveLivePhoto is not defined.");
  //     }
  //   },


  //   [webcamRef, saveLivePhoto]
  // );

  const capture = React.useCallback(async () => {

    if (!webcamRef.current) return;
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      console.error("Failed to capture image");
      return;
    }
    // Extract base64 data
    const img = imageSrc.split(',')[1];

    // Convert Base64 to Blob
    const base64Response = await fetch(`data:image/jpeg;base64,${img}`);
    const sendCandidatePhotoFile = await base64Response.blob();

    // Update state with the captured image
    setUploadLiveImage((prevState) => ({
      ...prevState,
      showCandidatePhotoBase64: img,
      showCandidatePhoto: "",
      sendCandidatePhotoFile: sendCandidatePhotoFile,
      defaultCandidatePhoto: "",
    }));

    // Validate captured image
    if (!sendCandidatePhotoFile || sendCandidatePhotoFile.type === 'text/html') {
      setErrorLivePhoto(profileuploadphotosignature.LIVE_PHOTO_REQUIRED);
      return;
    }

    // Update UI
    setTermsAndCondition(false);
    dispatch(setLiveImagesrc(imageSrc));
    setShowSuccessLivePhotoModal(true);
    setIsCameraOn(false);
    setTimer(0);
    if (intervalId) clearInterval(intervalId);

    setEditLivePhotoFlg(false)

    // Send photo to API
    if (typeof saveLivePhoto === "function") {
      saveLivePhoto(sendCandidatePhotoFile);
    } else {
      console.error("saveLivePhoto is not defined.");
    }

    savePhotoAndSignature()

  }, [webcamRef, saveLivePhoto]);



  const modalConfirm = () => {
    dispatch(submitProfile());
    setShowModal(false);
    setTermsAndCondition(false)
    setIsSaved(false)
    dispatch(disableAllSaveAfterSubmit(true))
    setEditHindiSignFlg(false)
    setEditEngSignFlg(false)
  };

  

  const disableSubmit = () => {
    let finalFlgSubmittable = true;
    let flgSubmittableListValueArray = Object.values(flgSubmittableList);

    for (let i = 0; i < flgSubmittableListValueArray.length; i++) {
      if (!flgSubmittableListValueArray[i]) {
        finalFlgSubmittable = false
        break
      };
    }

    let flgDisableSubmit = false;

    if (profileStatus) {
      flgDisableSubmit = true
    }
    else if ((uploadLiveImage.showCandidatePhoto == "" || uploadLiveImage.showCandidatePhoto.length == 0) && (uploadLiveImage.showCandidatePhotoBase64 == "" || uploadLiveImage.showCandidatePhotoBase64.length == 0)) {
      flgDisableSubmit = true;
    }
    else {
      flgDisableSubmit = !finalFlgSubmittable
    }
    if (flgDisableSubmit === false) {
      if (termsAndCondition === true) {
        return flgDisableSubmit;
      }
      else {
        return true
      }
    } else {
      return true
    }

  }


  const changeFlag = async (e) => {

    if (!getUploadedImages.livephoto || editLivePhotoFlg) {
      toastr.warning(commonENLabels.LIVE_PHOTO_WARNING);
      return;
    }

    if (!getUploadedImages.signature || editEngSignFlg) {
      toastr.warning(commonENLabels.ENGLISH_SIGN_WARNING)
      return
    }

    if (!getUploadedImages.hinSignature || editHindiSignFlg) {
      toastr.warning(commonENLabels.HINDI_SIGN_WARNING)
      return
    }

    // if (!isSaved) {
    //   toastr.warning(commonENLabels.SIGNATURE_PHOTO_WARNING);
    //   return;
    // }

    let temp = e.target.value
    if (temp === 'false') {
      setTermsAndCondition(true)
    } else {
      setTermsAndCondition(false)
    }
  }

  const formattedUpdatedDate = new Date(profileSummaryInfo?.profile?.updatedAt).toLocaleDateString("en-GB");

  return (
    <div className='p-4 f12'>
      {arraymModule && arraymModule.isEnabled === false ? "" :
        <div>
          <div className="p-1 bg-blue date_flex">
            <h5 className="text-white">
              <img src="/icons/user-detail.png" /> &nbsp;{commonENLabels.PHOTO_SIGNATURE.PHOTO_SIGNATURE} : {commonHILabels.PHOTO_SIGNATURE.PHOTO_SIGNATURE}
            </h5>
            <h5 className="text-white last_updated_date">
              {commonENLabels.LAST_UPDATED_ON}{" "}
              {getFormattedLastUpdatedDate(formattedUpdatedDate)}
            </h5>
          </div>
          <div className='row'>
            <div className='col-md-12 pt-4 '>
              <h5 className='bottom-dotted-line align-left p-1'>{numberformat["6"]}.&nbsp;{commonENLabels.PHOTO_SIGNATURE.PHOTO_AND_SIGNATURE} : {commonHILabels.PHOTO_SIGNATURE.PHOTO_AND_SIGNATURE}</h5>
            </div>
          </div>
        </div>}
      {arraymModule && arraymModule.isEnabled === false ?
        <div> <p className="Note-color f13" >{arraymModule.msgToDisplay}</p></div> :
        <>
          {/* <div className="row mt-2">
            <div className='col-md-10'>
              <h6 className='mb-0'>
                <label className="LeftText f13 fw-bold">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH}</label>
                <label className="f13 margin-top-10">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH}</label>
              </h6>
              <h6>
                <label className="LeftText f11 text-danger">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE}</label>
                <label className="f11 margin-top-10 text-blue ">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_1}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_1}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_2}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_2}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_3}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_PHOTOGRAPH_NOTE_3}</label>
              </h6>
            </div>
            <div className="col-md-2">

              <div className="imageSection" >
                {((uploadImage.showCandidatePhoto !== "" && uploadImage.showCandidatePhoto.length > 0) || (uploadImage.showCandidatePhotoBase64 !== "" && uploadImage.showCandidatePhotoBase64 !== null)) ? <span className="removeCandidateImage" title={profileuploadphotosignature.REMOVE_PHOTO} onClick={removeCandidateImage}>X</span> : ''}
                {((uploadImage.showCandidatePhoto !== "" && uploadImage.showCandidatePhoto.length > 0) || (uploadImage.showCandidatePhotoBase64 !== "" && uploadImage.showCandidatePhotoBase64 !== null)) ?
                  <img src={(uploadImage.showCandidatePhoto !== "" && uploadImage.showCandidatePhoto.length > 0) ? `${uploadImage.showCandidatePhoto}` : `data:image/png;base64, ${uploadImage.showCandidatePhotoBase64}`} width="145" height="120" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_PHOTO} /> :
                  <div className='uploadImgPhotoCss ms-4'><img src="/logos/default-photo.png" width="100%" height="100%" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.DEFUALT_PHOTO} />
                  </div>}
                <input type="file" name="image" id="image" accept=".png, .jpg" onChange={(event) => onChangeImage(event)} className='d-none' />
                <label htmlFor="image" className="uploadImageLabelImg text-blue mt-1" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CHOOSE_CANDIDATE_PHOTO}>{profileuploadphotosignature.CHOOSE_FILE}</label>
                {(errorPhoto != "" && (uploadImage.showCandidatePhoto == "" || uploadImage.showCandidatePhoto.length == null || uploadImage.showCandidatePhoto.length == "") && uploadImage.showCandidatePhotoBase64 == "") ? <span className='errorMsg'>{errorPhoto}</span> : ''}
              </div>
            </div>
          </div> */}
          <div className="row mt-2 mt-2">
            <div className='col-md-10'>
              <h6 className='mb-0'>
                <label className="LeftText f13 fw-bold">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_LIVE_PHOTOGRAPH}</label>
                <label className="f13 margin-top-10">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_LIVE_PHOTOGRAPH}</label>
              </h6>
              <p className="text-start d-flex align-items-start mb-1">
                <span className="mt-1">
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_QUE_1}
                  </span><br />
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_1}
                  </span>
                  <br />
                  <span>
                    {commonHILabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_1}
                  </span>
                </span>
              </p>
              <p className="text-start d-flex align-items-start mb-1">
                <span>
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_QUE_2}
                  </span><br />
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_2}
                  </span>
                  <br />
                  <span>
                    {commonHILabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_2}
                  </span>
                </span>
              </p>
              <p className="text-start d-flex align-items-start mb-1">
                <span>
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_QUE_3}
                  </span><br />
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_3}
                  </span>
                  <br />
                  <span>
                    {commonHILabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_3}
                  </span>
                </span>
              </p>
              <p className="text-start d-flex align-items-start mb-1">
                <span>
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_QUE_4}
                  </span><br />
                  <span className="text-dark">
                    {commonENLabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_4}
                  </span>
                  <br />
                  <span>
                    {commonHILabels.PHOTO_SIGNATURE.LIVE_PHOTO_CAPTURE_ANS_4}
                  </span>
                </span>
              </p>
            </div>
            <div className="col-md-2 mt-2">
              <div className="imageSection" >

                {
                  props.profileStatus !== true ? (
                    <>
                      {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ?
                        <span className="removeCandidateImage" title={profileuploadphotosignature.REMOVE_PHOTO} onClick={removeCandidateLiveImage}>X</span> : ''}
                    </>
                  ) : (
                    <>
                      {props.enableEditProfileWithLock?.editProfileWithLock == "1" &&
                        props.enableEditProfileWithLock?.PhotoInfo?.split(",").includes("D") && (
                          <>
                            {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ?
                              <span className="removeCandidateImage" title={profileuploadphotosignature.REMOVE_PHOTO} onClick={removeCandidateLiveImage}>X</span> : ''}
                          </>
                        )}
                    </>
                  )}

                {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ?
                  <img src={(uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) ? `${uploadLiveImage.showCandidatePhoto}` : `data:image/png;base64, ${uploadLiveImage.showCandidatePhotoBase64}`} width="145" height="120" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_PHOTO} /> :
                  ""}


                {showName ?
                  (<div>
                    {/* Webcam Modal */}
                    <Modal show={showName} onHide={hideModal} size="s" backdrop="static" centered>
                      <Modal.Header className="custom-modal-header logout_heading">
                        <Modal.Title className='logout_title'>
                          Live Photo Capture
                        </Modal.Title>
                        <button
                          type="button"
                          className="ms-auto logout_close"
                          aria-label="Close"
                          onClick={hideModal}
                        >X</button>
                      </Modal.Header>

                      <Modal.Body className="d-flex flex-column align-items-center">
                        {/* Webcam Preview */}
                        <div className="pb-3">

                          <p className="text-center " >Hi , <span className="text-primary">{profileSummaryInfo.englishFullName} </span> <br /> Are you ready for live photo ?</p>
                          <br />
                          <p className='text-center  error'> <span className='text-danger  text-center'> {timer}</span>  seconds to go</p>
                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-center gap-3">
                          {/* <Button type="button" className=" btn btn-primary custom_button  btn-sm setImgCss livePhotoBtn text-blue" onClick={takePhoto}>Ok</Button> */}
                          {/* <Button type="button" className="btn btn-secondary btn-sm cancelSetImgCss livePhotoBtn text-blue" onClick={() => { setIsCameraOn(false) }}>{commonLabels.CANCEL}</Button> */}
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>) :
                  <div className="pb36">
                    {/* <ImageCropper /> */}
                  </div>
                }

                {isCameraOn ?
                  (<div>
                    {/* Webcam Modal */}
                    <Modal show={isCameraOn} onHide={hideModal} size="s" backdrop="static" centered>
                      <Modal.Header className="custom-modal-header logout_heading">
                        <Modal.Title className='logout_title'>Live Photo Capture</Modal.Title>

                        <button
                          type="button"
                          className="ms-auto logout_close"
                          aria-label="Close"
                          onClick={hideModal}
                        >X</button>
                      </Modal.Header>

                      <Modal.Body className="d-flex flex-column align-items-center">
                        {/* Webcam Preview */}
                        <div className="pb-3">
                          <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            className="w-100 h-100 rounded shadow"
                          />
                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-center gap-3">
                          <Button type="button" className=" btn btn-primary custom_button  btn-sm setImgCss livePhotoBtn text-blue" onClick={capture}>{commonLabels.SET_IMAGE}</Button>
                          <Button type="button" className="btn btn-secondary btn-sm cancelSetImgCss livePhotoBtn text-blue" onClick={hideModal}>{commonLabels.CANCEL}</Button>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>) :
                  <div className="pb36">
                    {/* <ImageCropper /> */}
                  </div>
                }


                {showSuccessLivePhotoModal ?
                  (<div>
                    {/* Webcam Modal */}
                    <Modal show={showSuccessLivePhotoModal} onHide={hideModal} size="s" backdrop="static" centered>
                      <Modal.Header className="custom-modal-header logout_heading">
                        <Modal.Title className='logout_title'>
                          Live Photo Capture Status
                        </Modal.Title>
                        <button
                          type="button"
                          className="ms-auto logout_close"
                          aria-label="Close"
                          onClick={hideModal}
                        >X</button>

                      </Modal.Header>

                      <Modal.Body className="d-flex flex-column align-items-center">
                        {/* Webcam Preview */}
                        <div className="pb-3">

                          {/* {livePhotoMessage && <div>
                            <h5 className='panMessage'> Live Photo Capturing <span className='errorText'>*</span> </h5>
                            <br /> */}
                          {setLivephotoFlg ? <p className="text-center h4" >Thank You , <span className="text-primary">{profileSummaryInfo.englishFullName} </span> <br /> </p> : <p className="text-center h4" > <span className='text-danger'> Attention !, </span>  <span className="text-primary">{profileSummaryInfo.englishFullName} <span className='h5'>Capture again</span> </span> <br /> </p>}
                          <p className={`panMessage  ${setLivephotoFlg ? "livePhotoSuccessText" : "livePhotoErrorText"} `}>{setLivePhotoMessage}</p>
                          {/* </div>} */}
                        </div>
                        {/* Buttons */}
                        <div className="d-flex justify-content-center gap-3">
                          <Button type="button" className=" btn btn-primary custom_button  btn-sm setImgCss livePhotoBtn text-blue" onClick={() => setShowSuccessLivePhotoModal(false)}>Ok</Button>
                          {!setLivephotoFlg && <Button type="button" className="btn btn-secondary btn-sm cancelSetImgCss livePhotoBtn text-blue" onClick={() => { setIsCameraOn(true) }}>{commonLabels.CAPTURE_AGAIN}</Button>}
                          {/* <Button type="button" className="btn btn-secondary btn-sm cancelSetImgCss livePhotoBtn text-blue" onClick={() => { setIsCameraOn(false) }}>{commonLabels.CAPTURE_AGAIN}</Button> */}
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>) :
                  <div className="pb36">
                    {/* <ImageCropper /> */}
                  </div>
                }
                {(errorLivePhoto != "" && (uploadLiveImage.showCandidatePhoto == "" || uploadLiveImage.showCandidatePhoto.length == null || uploadLiveImage.showCandidatePhoto.length == "") && uploadLiveImage.showCandidatePhotoBase64 == "") ? <span className='errorMsg'>{errorLivePhoto}</span> : ''}

                {
                  props.profileStatus !== true ? (
                    <>
                      <button className=' btn btn-primary custom_button  mt-3 livePhotoBtn text-blue' onClick={popupName} >{profileuploadphotosignature.LIVE_PHOTO} <i className="fa fa-camera fa-lg m-1" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CAMERA}></i></button><br />
                    </>
                  ) : (
                    (() => {
                      const photoInfoList = props.enableEditProfileWithLock?.PhotoInfo?.split(",") || [];
                      const canCreate = photoInfoList.includes("C");
                      const canUpdate = photoInfoList.includes("U");
                      const isEditable = props.enableEditProfileWithLock?.editProfileWithLock == "1";

                      if (isEditable && (canCreate || canUpdate)) {
                        return (
                          <>
                            <button
                              className="btn btn-primary custom_button mt-3 livePhotoBtn text-blue"
                              onClick={popupName}
                            >
                              {profileuploadphotosignature.LIVE_PHOTO}
                              <i
                                className="fa fa-camera fa-lg m-1"
                                aria-hidden="true"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title={profileuploadphotosignature.CAMERA}
                              ></i>
                            </button>
                            <br />
                          </>
                        );
                      } else {
                        return null; // Or a read-only message if you want
                      }
                    })()
                  )
                }


                {/* {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ? <button className=' btn btn-primary custom_button  mt-1 livePhotoBtn text-blue' onClick={showLiveImageCropper}>{profileuploadphotosignature.LIVE_PHOTO_CROP} <i className="fa fa-crop fa-lg m-1" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CROP_PHOTO}></i> </button> : ''} */}
              </div>
              {/* <h5 className="live_verification_box mt-2 mb-0">Live Photo Verified : {setLivephotoFlg === false ? <span className='errorText'><ImCross /></span> : <span className='successText  '><FaCheck /> </span>}</h5> */}
            </div>
          </div>

          {/* {setShowModalStatus && <CustomModal setShowModalStatus={setShowModalStatus} photoMessage={setUploadedPhotoMessage} livePhotoMessage={setLivePhotoMessage} />} */}


          <div className="row mt-4">
            <div className='col-md-10'>
              <h6 className='mb-0'>
                <label className="LeftText f13 fw-bold">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE}</label>
                <label className="f13 margin-top-10">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE}</label>
              </h6>
              <h6>
                <label className="LeftText f11 text-danger">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_1}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_1}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_2}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_2}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_3}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_3}</label>
              </h6>
            </div>
            <div className="col-md-2">
              <div className="imageSection" >
                {
                  props.profileStatus !== true ? (
                    <>
                      {((uploadSignature.showSignature !== "" && uploadSignature.showSignature !== null) || (uploadSignature.showSignatureBase64 !== "" && uploadSignature.showSignatureBase64 !== null)) ?
                        <span className="removeSignatureImage" title={profileuploadphotosignature.REMOVE_SIGNATURE} onClick={removeSignatureImage} >X</span> : ''}
                    </>
                  ) : (
                    <>
                      {props.enableEditProfileWithLock?.editProfileWithLock == "1" &&
                        props.enableEditProfileWithLock?.PhotoInfo?.split(",").includes("D") && (
                          <>
                            {((uploadSignature.showSignature !== "" && uploadSignature.showSignature !== null) || (uploadSignature.showSignatureBase64 !== "" && uploadSignature.showSignatureBase64 !== null)) ?
                              <span className="removeSignatureImage" title={profileuploadphotosignature.REMOVE_SIGNATURE} onClick={removeSignatureImage} >X</span> : ''}
                          </>
                        )}

                    </>
                  )}

                {((uploadSignature.showSignature !== "" && uploadSignature.showSignature !== null) || (uploadSignature.showSignatureBase64 !== "" && uploadSignature.showSignatureBase64 !== null)) ?
                  <img src={(uploadSignature.showSignature !== "" && uploadSignature.showSignature !== null) ? uploadSignature.showSignature : `data:image/png;base64,${uploadSignature.showSignatureBase64}`} width="200" height="60" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_SIGNATURE} /> :
                  <div className='uploadImgPhotoCss ms-4'><img src="/logos/default-signature.png" width="100%" height="100%" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.DEFUALT_SIGNATURE} />
                  </div>}
                <input type="file" name="signature" id="signature" accept=".png, .jpg" onChange={(event) => onChangeSignature(event)} className='d-none' />
                {
                  props.profileStatus !== true ? (
                    <label
                      htmlFor="signature"
                      className="uploadImageLabelImg text-blue mt-1"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title={profileuploadphotosignature.CHOOSE_CANDIDATE_SIGNATURE}
                    >
                      {profileuploadphotosignature.CHOOSE_FILE}
                    </label>
                  ) : (
                    (() => {
                      const photoInfoList = props.enableEditProfileWithLock?.PhotoInfo?.split(",") || [];
                      const canCreate = photoInfoList.includes("C");
                      const canUpdate = photoInfoList.includes("U");
                      const isEditable = props.enableEditProfileWithLock?.editProfileWithLock == "1";

                      if (isEditable && (canCreate || canUpdate)) {
                        return (
                          <label
                            htmlFor="signature"
                            className="uploadImageLabelImg text-blue mt-1"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={profileuploadphotosignature.CHOOSE_CANDIDATE_SIGNATURE}
                          >
                            {profileuploadphotosignature.CHOOSE_FILE}
                          </label>
                        );
                      } else {
                        return null; // Or a read-only message if you want
                      }
                    })()
                  )
                }

                {/* {((uploadSignature.showSignature !== "" && uploadSignature.showSignature !== null) || (uploadSignature.showSignatureBase64 !== "" && uploadSignature.showSignatureBase64 !== null)) ? <i className="fa fa-crop fa-lg m-1" onClick={showSignatureCropper} aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CROP_SIGNATURE}></i> : ''} */}
                {(errorSign != "" && uploadSignature.showSignature == "" && uploadSignature.showSignatureBase64 == "") ? <span className='errorMsg'>{errorSign}</span> : ''}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className='col-md-10'>
              <h6 className='mb-0'>
                <label className="LeftText f13 fw-bold">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_HIN}</label>
                <label className="f13 margin-top-10">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_HIN}</label>
              </h6>
              <h6>
                <label className="LeftText f11 text-danger">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_1}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_1}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_2}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_2}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_3}</label>
                <label className="f11 margin-top-10 text-blue">{commonHILabels.PHOTO_SIGNATURE.INSTRUCTION_FOR_SIGNATURE_NOTE_3}</label>
              </h6>
            </div>
            <div className="col-md-2">
              <div className="imageSection" >
                {
                  props.profileStatus !== true ? (
                    <>
                      {((uploadHindiSignature.showHindiSignature !== "" && uploadHindiSignature.showHindiSignature !== null) || (uploadHindiSignature.showHindiSignatureBase64 !== "" && uploadHindiSignature.showHindiSignatureBase64 !== null)) ?
                        <span className="removeSignatureImage" title={profileuploadphotosignature.REMOVE_SIGNATURE} onClick={removeHindiSignatureImage} >X</span> : ''}
                    </>
                  ) : (
                    <>
                      {props.enableEditProfileWithLock?.editProfileWithLock == "1" &&
                        props.enableEditProfileWithLock?.PhotoInfo?.split(",").includes("D") && (
                          <>
                            {((uploadHindiSignature.showHindiSignature !== "" && uploadHindiSignature.showHindiSignature !== null) || (uploadHindiSignature.showHindiSignatureBase64 !== "" && uploadHindiSignature.showHindiSignatureBase64 !== null)) ?
                              <span className="removeSignatureImage" title={profileuploadphotosignature.REMOVE_SIGNATURE} onClick={removeHindiSignatureImage} >X</span> : ''}
                          </>
                        )}

                    </>
                  )}

                {((uploadHindiSignature.showHindiSignature !== "" && uploadHindiSignature.showHindiSignature !== null) || (uploadHindiSignature.showHindiSignatureBase64 !== "" && uploadHindiSignature.showHindiSignatureBase64 !== null)) ?
                  <img src={(uploadHindiSignature.showHindiSignature !== "" && uploadHindiSignature.showHindiSignature !== null) ? uploadHindiSignature.showHindiSignature : `data:image/png;base64,${uploadHindiSignature.showHindiSignatureBase64}`} width="200" height="60" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_SIGNATURE} /> :
                  <div className='uploadImgPhotoCss ms-4'><img src="/logos/default-signature.png" width="100%" height="50%" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.DEFUALT_SIGNATURE} />
                  </div>}
                <input type="file" name="hinSignature" id="hinSignature" accept=".png, .jpg" onChange={(event) => onChangeHindiSignature(event)} className='d-none' />
                {
                  props.profileStatus !== true ? (
                    <>
                      <label
                        htmlFor="hinSignature"
                        className="uploadImageLabelImg text-blue mt-1"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={profileuploadphotosignature.CHOOSE_CANDIDATE_SIGNATURE}
                      >
                        {profileuploadphotosignature.CHOOSE_FILE}
                      </label>
                    </>
                  ) : (
                    (() => {
                      const photoInfoList = props.enableEditProfileWithLock?.PhotoInfo?.split(",") || [];
                      const canCreate = photoInfoList.includes("C");
                      const canUpdate = photoInfoList.includes("U");
                      const isEditable = props.enableEditProfileWithLock?.editProfileWithLock == "1";

                      if (isEditable && (canCreate || canUpdate)) {
                        return (
                          <label
                            htmlFor="hinSignature"
                            className="uploadImageLabelImg text-blue mt-1"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={profileuploadphotosignature.CHOOSE_CANDIDATE_SIGNATURE}
                          >
                            {profileuploadphotosignature.CHOOSE_FILE}
                          </label>
                        );
                      } else {
                        return null; // Or a read-only message if you want
                      }
                    })()
                  )
                }


                {/* {((uploadHindiSignature.showHindiSignature !== "" && uploadHindiSignature.showHindiSignature !== null) || (uploadHindiSignature.showHindiSignatureBase64 !== "" && uploadHindiSignature.showHindiSignatureBase64 !== null)) ? <i className="fa fa-crop fa-lg m-1" onClick={showSignatureCropper} aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CROP_SIGNATURE}></i> : ''} */}
                {(errorHindiSign != "" && uploadHindiSignature.showHindiSignature == "" && uploadHindiSignature.showHindiSignatureBase64 == "") ? <span className='errorMsg'>{errorHindiSign}</span> : ''}
              </div>
            </div>
          </div>
        </>
      }
      <div className='text-start m-2'>
        {arraymModule && arraymModule.isEnabled === false ? "yes" :
          (editEngSignFlg || editHindiSignFlg) ? (
            <div className="d-flex justify-content-center">
              {
                props.profileStatus !== true ? (
                  <button
                    type="button"
                    className="btn btn-primary custom_button m-1"
                    onClick={savePhotoAndSignature}
                    disabled={isDisableAllTabSave}
                  >
                    {profile.SAVE}
                  </button>
                ) : (
                  (() => {
                    const photoInfoList = props.enableEditProfileWithLock?.PhotoInfo?.split(",") || [];
                    const canCreate = photoInfoList.includes("C");
                    const canUpdate = photoInfoList.includes("U");
                    const hasDelete = photoInfoList.includes("D");
                    const isReadOnly = photoInfoList.includes("R");

                    if (props.enableEditProfileWithLock?.editProfileWithLock == "1") {
                      if (canCreate || canUpdate || hasDelete) {
                        return (
                          <button
                            type="button"
                            className="btn btn-primary custom_button m-1"
                            onClick={savePhotoAndSignature}
                            disabled={isDisableAllTabSave}
                          >
                            {profile.SAVE}
                          </button>
                        );
                      } else if (isReadOnly && !canCreate && !canUpdate) {
                        return (
                          <span className="profile_disable_button m-2">
                            {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                          </span>
                        );
                      }
                    }

                    return null;
                  })()
                )
              }
              {/* {
                props.profileStatus !== true ? (
                  <button
                    type="button"
                    className="btn btn-primary custom_button m-1"
                    onClick={savePhotoAndSignature}
                    disabled={isDisableAllTabSave}
                  >
                    {profile.SAVE}
                  </button>
                ) : (
                  <span className="profile_disable_button m-2">
                    {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                  </span>
                )} */}
            </div>
          ) : null
        }
        <hr></hr>
        {submitLockProfile && submitLockProfile.isEnabled === false ?
          <div> <p className="Note-color f13" >{submitLockProfile.msgToDisplay}</p></div>
          :
          <div>

            <div className="form-check">
              {
                props.profileStatus !== true ? (
                  <div className='flex'>

                    <input className={`form-check-input mt-2 f13 declaration-checkbox `} type="checkbox" value={termsAndCondition} id="flexCheckChecked" checked={termsAndCondition} onChange={(e) => { changeFlag(e) }} />
                    <p className='declaration'>I Agree</p>
                  </div>
                ) : (
                  ""
                )}
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_1}</label>
                <label className="f11 mt-1 text-blue">{commonHILabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_1}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_2}</label>
                <label className="f11 mt-1 text-blue">{commonHILabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_2}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_3}</label>
                <label className="f11 mt-1 text-blue">{commonHILabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_3}</label>
              </h6>
              <h6 className='mb-0'>
                <label className="LeftText f11 font-weight">{commonENLabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_4}</label>
                <label className="f11 mt-1 text-blue">{commonHILabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_4}</label>
              </h6>
            </div>
            <div className="d-flex justify-content-center">

              {
                props.profileStatus !== true ? (
                  <button
                    type="button"
                    className="btn btn-primary custom_button mt-4"
                    onClick={() => setShowModal(true)}
                    disabled={disableSubmit()}
                  >
                    {commonENLabels.PHOTO_SIGNATURE.SUBMIT_LOCK}
                  </button>
                ) : (
                  (() => {
                    const photoInfoList = props.enableEditProfileWithLock?.PhotoInfo?.split(",") || [];
                    const canCreate = photoInfoList.includes("C");
                    const canUpdate = photoInfoList.includes("U");
                    const isReadOnly = photoInfoList.includes("R");

                    if (props.enableEditProfileWithLock?.editProfileWithLock == "1") {
                      if (canCreate || canUpdate) { 
                        return (''
                          // <button
                          //   type="button"
                          //   className="btn btn-primary custom_button mt-4"
                          //   onClick={() => setShowModal(true)}
                          //   disabled={disableSubmit()}
                          // >
                          //   {commonENLabels.PHOTO_SIGNATURE.SUBMIT_LOCK}
                          // </button>
                        );
                      } else if (isReadOnly && !canCreate && !canUpdate) {
                        return (                        
                            <span className="profile_disable_button mt-4">
                            {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                          </span>     
                      
                          
                        );
                      }
                    }

                    return null;
                  })()
                )
              }
            </div>
          </div>}
      </div>
      <Modal show={showModal} onHide={() => { setShowModal(false) }} backdrop='static'>
        <Modal.Header className="custom-modal-header logout_heading">
          <Modal.Title className='logout_title'>{profile.SUBMIT_LOCK}</Modal.Title>
          <button
            type="button"
            className="ms-auto logout_close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          >X</button>
        </Modal.Header>
        <Modal.Body>
          {common.SUBMIT_PROFILE_MESSAGE}<br/>
          {common.SUBMIT_PROFILE_MESSAGE_2}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => { setShowModal(false) }}>{common.CANCEL}</button>
          <button className=" btn btn-primary custom_button " onClick={modalConfirm}>{common.CONFIRM}</button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default UploadPhotoAndSignature;